import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  theme: 'dark',
  sidebarOpen: true,
  sidebarTab: 'all',        // all, forex, crypto, metal, index, commodity
  sidebarCat: 'all',        // all, fav
  favorites: [],
  chartType: 'candle',      // candle, line, area
  activeTimeframe: '1D',    // 1M, 5M, 15M, 1H, 1D, 1W
  lotSize: 0.01,
  maxLot: 1.00,
  leverage: '1:100',
  activeInstrument: null,
  toast: {
    show: false,
    message: '',
    type: 'info',           // info, success, error, warning
  },
  modals: {
    buyModal: false,
    sellModal: false,
    orderModal: false,
  },
  bottomTab: 'active',      // active, pending, history
  rightPanelTab: 'trade',   // trade, holdings, account
  centerTab: 'chart',       // chart, table
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'dark' ? 'light' : 'dark';
    },
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },
    setSidebarTab: (state, action) => {
      state.sidebarTab = action.payload;
    },
    setSidebarCat: (state, action) => {
      state.sidebarCat = action.payload;
    },
    toggleFavorite: (state, action) => {
      const id = action.payload;
      if (state.favorites.includes(id)) {
        state.favorites = state.favorites.filter(f => f !== id);
      } else {
        state.favorites.push(id);
      }
    },
    setChartType: (state, action) => {
      state.chartType = action.payload;
    },
    setActiveTimeframe: (state, action) => {
      state.activeTimeframe = action.payload;
    },
    setLotSize: (state, action) => {
      state.lotSize = action.payload;
    },
    setMaxLot: (state, action) => {
      state.maxLot = action.payload;
    },
    setLeverage: (state, action) => {
      state.leverage = action.payload;
    },
    setActiveInstrument: (state, action) => {
      state.activeInstrument = action.payload;
    },
    showToast: (state, action) => {
      state.toast = {
        show: true,
        message: action.payload.message,
        type: action.payload.type || 'info',
      };
    },
    hideToast: (state) => {
      state.toast.show = false;
    },
    openModal: (state, action) => {
      state.modals[action.payload] = true;
    },
    closeModal: (state, action) => {
      state.modals[action.payload] = false;
    },
    setBottomTab: (state, action) => {
      state.bottomTab = action.payload;
    },
    setRightPanelTab: (state, action) => {
      state.rightPanelTab = action.payload;
    },
    setCenterTab: (state, action) => {
      state.centerTab = action.payload;
    },
  },
});

export const {
  toggleTheme,
  toggleSidebar,
  setSidebarTab,
  setSidebarCat,
  toggleFavorite,
  setChartType,
  setActiveTimeframe,
  setLotSize,
  setMaxLot,
  setLeverage,
  setActiveInstrument,
  showToast,
  hideToast,
  openModal,
  closeModal,
  setBottomTab,
  setRightPanelTab,
  setCenterTab,
} = uiSlice.actions;

export default uiSlice.reducer;